module.exports = __webpack_public_path__ + "static/media/feedbackIcon.b6119982.svg";